import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import MuiMenu from "@mui/material/Menu";
import { makeStyles } from "@mui/styles";
import { RaiseColors } from "componentLibrary";
import * as React from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles({
  menuContainer: {
    outline: "none"
  },
  defaultMenu: {
    borderRadius: 16,
    boxShadow: "0px 4px 32px 0px ".concat(RaiseColors.neutral500, "33"),
    marginTop: "8px"
  }
});
var Menu = function Menu(_ref) {
  var disabled = _ref.disabled,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    renderToggle = _ref.renderToggle,
    toggleComponent = _ref.toggleComponent,
    className = _ref.className,
    children = _ref.children,
    anchorOrigin = _ref.anchorOrigin,
    transformOrigin = _ref.transformOrigin,
    style = _ref.style,
    menuStyle = _ref.menuStyle;
  var classes = useStyles();
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchorEl = _React$useState2[0],
    setAnchorEl = _React$useState2[1];
  var handleOpen = function handleOpen(event) {
    event.stopPropagation();
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };
  var handleClose = function handleClose(event) {
    event.stopPropagation();
    setAnchorEl(undefined);
    if (onClose) onClose(event);
  };
  if (renderToggle == null) {
    renderToggle = function renderToggle() {
      return /*#__PURE__*/_jsx("span", {
        "data-testid": "default-render-toggle",
        onClick: handleOpen,
        children: toggleComponent
      });
    };
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderToggle({
      handleOpenClick: handleOpen,
      handleCloseClick: handleClose,
      isOpen: !!anchorEl
    }), /*#__PURE__*/_jsx(MuiMenu, {
      classes: {
        paper: className !== null && className !== void 0 ? className : classes.defaultMenu
      },
      anchorEl: anchorEl,
      open: !!anchorEl,
      onClose: handleClose,
      anchorOrigin: anchorOrigin !== null && anchorOrigin !== void 0 ? anchorOrigin : {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: transformOrigin !== null && transformOrigin !== void 0 ? transformOrigin : {
        vertical: "top",
        horizontal: "left"
      },
      getContentAnchorEl: null,
      "data-testid": "menu-component-id",
      style: menuStyle,
      children: /*#__PURE__*/_jsx("div", {
        "data-testid": "menu-children-container",
        className: classes.menuContainer,
        onClick: handleClose,
        style: style,
        children: children
      })
    })]
  });
};
export default Menu;